/*
 * @Author: yuanjianlong
 * @Description:
 * @Date: 2025-10-20 17:00:21
 * @LastEditTime: 2025-10-20 17:34:35
 * @LastEditors: yuanjianlong
 * @FilePath: /st-teacher-2020/src/utils/tool.ts
 */
// @ts-ignore
import TkSdk from '@aixuexi/tksdk';
import { debounce } from 'lodash';

const tkSdkNew = new TkSdk();
tkSdkNew.loadMathjaxSvg();
// 解析公式
const onMathJax = debounce(
  () => {
    tkSdkNew.runMathjax();
    setTimeout(() => {
      tkSdkNew.runMathjax();
    }, 800);
  },
  300,
  {
    leading: true, // 延迟开始前调用
  },
);
const colatex2svg = (data: string) => {
  onMathJax();
  return data;
};

export {
  onMathJax,
  colatex2svg,
};
